import {
    BackspaceOutlined as BackspaceOutlinedIcon,
    DeleteForeverOutlined as DeleteForeverOutlinedIcon,
    EditTwoTone as EditTwoToneIcon,
    Search as SearchIcon,
    VisibilityOutlined as VisibilityOutlinedIcon
} from '@material-ui/icons';
import {
    Box,
    Button,
    Card,
    CardContent,
    Checkbox,
    FormControlLabel,
    Input,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip
} from '@material-ui/core';
import { ANAO, ASIM } from 'consts';
import api from '../../../services/api';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ComboPadraoMultiple from 'views/Components/ComboPadraoMultiple';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import DeleteConfirmationModal from '../../../components/DeleteConfirmationModal/DeleteConfirmationModal';

class VeiculoList extends Component {
    state = {
        searchFilter: JSON.parse(sessionStorage.getItem('veiculoSearchFilter')) || {
            nroveiculo: '',
            descveiculo: '',
            capacidadepax: '',
            marcas: [],
            modelos: [],
            fornecedores: [],
            veiculoproprio: false,
            situacaoInativoFilter: ANAO
        },
        veiculos: [],
        listaMarcas: [],
        listaModelos: [],
        listaFornecedores: [],
        open: false,
        openAlert: false,
        messageAlert: '',
        selectedId: null,
        selectedDesc: '',
        totalItems: 0,
        page: Number(sessionStorage.getItem('veiculoPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('veiculoRowsPerPage')) || 10
    };

    estilo = {
        redText: { color: 'red' },
        addButton: {
            height: 42,
            display: 'flex',
            alignItems: 'center'
        },
        iconGroup: {
            display: 'inline-flex',
            gap: 5
        },
        actionIcon: {
            fontSize: 24,
            color: '#3f51b5',
            cursor: 'pointer'
        },
        marginTop: 30,
        marginLeft: 30,
        marginRight: 30
    };

    /* Altera a cor do ícone ao passar o cursor */
    handleIconMouseEnter = (event) => {
        event.currentTarget.style.color = '#2979ff';
    };

    /* Retorna à cor padrão do ícone ao remover o cursor */
    handleIconMouseLeave = (event) => {
        event.currentTarget.style.color = '#3f51b5';
    };

    /* Altera a cor do ícone de exclusão ao passar o cursor */
    handleDeleteIconMouseEnter = (event) => {
        event.currentTarget.style.color = 'red';
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        const [listaModelos] = await Promise.all([
            this.loadModelos(),
            this.loadMarcas(),
            this.loadFornecedores()
        ]);

        this.loadVeiculos(listaModelos);
    };

    /* Paginação */
    componentDidUpdate(prevProps, prevState) {
        const { searchFilter, page, rowsPerPage } = this.state;

        // persiste os filtros e a paginação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            sessionStorage.setItem('veiculoSearchFilter', JSON.stringify(searchFilter));
        }

        if (prevState.page !== page) {
            sessionStorage.setItem('veiculoPage', page);
        }

        if (prevState.rowsPerPage !== rowsPerPage) {
            sessionStorage.setItem('veiculoRowsPerPage', rowsPerPage);
        }
    };

    /* Limpa os filtros e a paginação ao sair da tela */
    componentWillUnmount() {
        sessionStorage.removeItem('veiculoSearchFilter');
        sessionStorage.removeItem('veiculoPage');
        sessionStorage.removeItem('veiculoRowsPerPage');
    };

    /* Carrega os fornecedores */
    loadFornecedores = async () => {
        try {
            const params = `?page=1&limit=500&transportadora=S`;
            const response = await api.get(`/fornecedor/active/true${params}`);
            const listaFornecedores = response.data.map(fornecedor => ({
                id: fornecedor.codfornecedor,
                item: fornecedor.descfornecedor
            }));

            this.setState({ listaFornecedores });

            return listaFornecedores;
        } catch (error) {
            console.error('Erro ao carregar fornecedores do veículo', error);

            return [];
        }
    };

    /* Carrega as marcas de veículo */
    loadMarcas = async () => {
        try {
            const response = await api.get('/marcaveiculo');
            const marcas = Array.isArray(response.data)
                ? response.data
                : (Array.isArray(response.data?.data) ? response.data.data : []);
            const listaMarcas = marcas.map(marca => ({
                id: marca.codmarcaveiculo,
                item: marca.descmarcaveiculo
            }));

            this.setState({ listaMarcas });

            return listaMarcas;
        } catch (error) {
            console.error('Erro ao carregar marcas de veículo', error);

            return [];
        }
    };

    /* Carrega os modelos de veículo */
    loadModelos = async () => {
        try {
            const response = await api.get('/modeloveiculo');
            const modelos = Array.isArray(response.data)
                ? response.data
                : (Array.isArray(response.data?.data) ? response.data.data : []);
            const listaModelos = modelos.map((modelo) => ({
                id: modelo.codmodeloveiculo,
                item: modelo.descmodeloveiculo,
                codmarcaveiculo: modelo.codmarcaveiculo
            }));

            this.setState({ listaModelos });

            return listaModelos;
        } catch (error) {
            console.error('Erro ao carregar modelos de veículo:', error);

            return [];
        }
    };

    /* Carrega os veículos */
    loadVeiculos = async (listaModelosCarregados) => {
        const { listaModelos, page, rowsPerPage, searchFilter } = this.state;
        const { capacidadepax, descveiculo, nroveiculo, situacaoInativoFilter } = searchFilter;
        const modelosBase = listaModelosCarregados || listaModelos;

        let params = `?page=${page + 1}&limit=${rowsPerPage}`;

        if (nroveiculo) {
            params += `&NROVEICULO=_like_${nroveiculo}`;
        }

        if (descveiculo) {
            params += `&DESCVEICULO=_like_${descveiculo}`;
        }

        if (capacidadepax) {
            params += `&CAPACIDADEPAX=_gte_${capacidadepax}`;
        }

        if (situacaoInativoFilter === ASIM || situacaoInativoFilter === ANAO) {
            params += `&INATIVO=${situacaoInativoFilter}`;
        }

        if (searchFilter.modelos && searchFilter.modelos.length > 0) {
            const codigos = searchFilter.modelos.map(m => m.id);
            params += `&CODMODELOVEICULO=_in_${codigos.join(',')}`;
        }

        if (searchFilter.marcas && searchFilter.marcas.length > 0) {
            // pega os ids das marcas selecionadas
            const codigoMarcas = searchFilter.marcas.map(m => m.id);

            // filtra os modelos que pertencem a essas marcas
            const modelosRelacionados = modelosBase.filter(
                modelo => codigoMarcas.includes(modelo.codmarcaveiculo)
            ).map(modelo => modelo.id);

            if (modelosRelacionados.length > 0) {
                params += `&CODMODELOVEICULO=_in_${modelosRelacionados.join(',')}`;
            }
        }

        if (searchFilter.fornecedores && searchFilter.fornecedores.length > 0) {
            const codigoFornecedores = searchFilter.fornecedores.map(f => f.id);
            params += `&CODFORNECEDORVEICULO=_in_${codigoFornecedores.join(',')}`;
        }

        if (searchFilter.veiculoproprio === true) {
            params += `&VEICULOPROPRIO=S`;
        }

        try {
            const response = await api.get('/veiculo' + params);

            this.setState({
                veiculos: response.data.data || [],
                totalItems: parseInt(response.data.info && response.data.info.totalrecords, 10) || 0
            });
        } catch (error) {
            console.error('Erro ao carregar veículos:', error);

            this.setState({
                veiculos: [],
                totalItems: 0
            });
        }
    };

    /* Muda a página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, this.loadVeiculos);
    };

    /* Muda a quantidade de retornos por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, this.loadVeiculos);
    };

    /* Deleta o veículo */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/veiculo/${id}`);

            // verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadVeiculos();
            }
        } catch (error) {
            this.handleClose();

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao excluir veículo!'
            );
        }
    };

    /* Confirma a exclusão */
    handleConfirmDelete = () => {
        const { selectedId } = this.state;

        this.handleDelete(selectedId);
    };

    /* Abre a janela de confirmação para a exclusão */
    handleOpen = (codveiculo, nroveiculo) => {
        this.setState({
            open: true,
            selectedId: codveiculo,
            selectedDesc: nroveiculo
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de confirmação da exclusão */
    handleClose = () => {
        this.setState({
            open: false,
            selectedId: null,
            selectedDesc: ''
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisa os filtros na tela */
    onChangeSearch = (event) => {
        const { checked, name, type, value } = event.target;

        const searchFilter = {
            ...this.state.searchFilter,
            [name]: type === 'checkbox'
                ? checked
                : (typeof value === 'string') ? value.toUpperCase() : value
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Pesquisar os modelos de veículo */
    onChangeModelos = (selected) => {
        const searchFilter = {
            ...this.state.searchFilter,
            modelos: selected
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Pesquisar as marcas de veículo */
    onChangeMarcas = (selected) => {
        const searchFilter = {
            ...this.state.searchFilter,
            marcas: selected
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Pesquisa os fornecedores de veículo */
    onChangeFornecedores = (selected) => {
        const searchFilter = {
            ...this.state.searchFilter,
            fornecedores: selected
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Limpa os filtros da tela */
    limpaFiltros = () => {
        const searchFilter = {
            nroveiculo: '',
            descveiculo: '',
            capacidadepax: '',
            situacaoInativoFilter: ANAO,
            modelos: [],
            marcas: [],
            fornecedores: [],
            veiculoproprio: false
        };

        this.setState({
            searchFilter,
            page: 0
        }, this.loadVeiculos);
    };

    render() {
        const {
            listaFornecedores,
            listaMarcas,
            listaModelos,
            messageAlert,
            open,
            openAlert,
            page,
            rowsPerPage,
            searchFilter,
            selectedDesc,
            selectedId,
            totalItems,
            veiculos
        } = this.state;

        const {
            actionIcon,
            addButton,
            iconGroup,
            redText
        } = this.estilo;

        return (
            <div style={this.estilo}>
                <Paper
                    hover
                    fullWidth
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        padding: '10px 20px',
                        gap: 15
                    }}
                >
                    <Input
                        autoFocus
                        id="nroveiculo"
                        name="nroveiculo"
                        onBlur={this.onInputBlur}
                        onChange={this.onChangeSearch}
                        placeholder="Veículo"
                        value={searchFilter.nroveiculo}
                        style={{
                            flex: '0 1 150px',
                            minWidth: 150
                        }}
                    />

                    <Input
                        id="descveiculo"
                        name="descveiculo"
                        onBlur={this.onInputBlur}
                        onChange={this.onChangeSearch}
                        placeholder="Descrição"
                        value={searchFilter.descveiculo}
                        style={{
                            flex: '0 1 150px',
                            minWidth: 150
                        }}
                    />

                    <Input
                        id="capacidadepax"
                        name="capacidadepax"
                        onBlur={this.onInputBlur}
                        onChange={this.onChangeSearch}
                        placeholder="Qtde. pax"
                        value={searchFilter.capacidadepax}
                        style={{
                            flex: '0 1 75px',
                            minWidth: 75
                        }}
                    />

                    <Select
                        id="situacaoInativoFilter"
                        name="situacaoInativoFilter"
                        value={searchFilter.situacaoInativoFilter || ''}
                        onChange={this.onChangeSearch}
                        style={{
                            flex: '0 1 100px',
                            minWidth: 100,
                            textAlign: 'center'
                        }}
                    >
                        <MenuItem
                            value={ANAO}
                            style={{ justifyContent: 'center' }}
                        >
                            Ativos
                        </MenuItem>

                        <MenuItem
                            value={ASIM}
                            style={{ justifyContent: 'center' }}
                        >
                            Inativos
                        </MenuItem>

                        <MenuItem
                            value={'T'}
                            style={{ justifyContent: 'center' }}
                        >
                            Todos
                        </MenuItem>
                    </Select>

                    <FormControlLabel
                        label="Exibir somente veículos próprios"
                        control={
                            <Checkbox
                                checked={searchFilter.veiculoproprio}
                                name="veiculoproprio"
                                onChange={this.onChangeSearch}
                                color="primary"
                            />
                        }
                    />

                    <span style={iconGroup}>
                        <Tooltip title="Procurar">
                            <SearchIcon
                                onClick={this.loadVeiculos}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>

                        <Tooltip title="Limpar">
                            <BackspaceOutlinedIcon
                                onClick={this.limpaFiltros}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to="/frotas/veiculo/novo"
                        variant="contained"
                        color="primary"
                        style={addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                <Paper
                    hover
                    fullWidth
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        padding: '10px 20px',
                        gap: 15
                    }}
                >
                    <Box
                        style={{
                            flex: '0 1 250px',
                            minWidth: 250
                        }}
                    >
                        <ComboPadraoMultiple
                            options={searchFilter.marcas}
                            label="Marcas"
                            itens={listaMarcas}
                            onSelectionChange={this.onChangeMarcas}
                        />
                    </Box>

                    <Box
                        style={{
                            flex: '0 1 250px',
                            minWidth: 250
                        }}
                    >
                        <ComboPadraoMultiple
                            options={searchFilter.modelos}
                            label="Modelos"
                            itens={listaModelos}
                            onSelectionChange={this.onChangeModelos}
                        />
                    </Box>

                    <Box
                        style={{
                            flex: '0 1 250px',
                            minWidth: 250
                        }}
                    >
                        <ComboPadraoMultiple
                            options={searchFilter.fornecedores}
                            label="Fornecedores"
                            itens={listaFornecedores}
                            onSelectionChange={this.onChangeFornecedores}
                        />
                    </Box>
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Código</TableCell>

                                            <TableCell align="center">Veículo</TableCell>

                                            <TableCell align="center">Capacidade Pax</TableCell>

                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {veiculos.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    colSpan={4}
                                                >
                                                    Nenhum veículo encontrado
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        {veiculos.map(veiculo => (
                                            <TableRow
                                                hover
                                                key={veiculo.codveiculo}
                                            >
                                                <TableCell
                                                    align="center"
                                                    style={(veiculo.inativo === ASIM) ? redText : {}}
                                                >
                                                    {veiculo.codveiculo}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(veiculo.inativo === ASIM) ? redText : {}}
                                                >
                                                    {veiculo.nroveiculo}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(veiculo.inativo === ASIM) ? redText : {}}
                                                >
                                                    {veiculo.capacidadepax}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <span style={iconGroup}>
                                                        <Tooltip title="Editar">
                                                            <Link to={`/frotas/veiculo/${veiculo.codveiculo}`}>
                                                                <EditTwoToneIcon
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Visualizar">
                                                            <Link to={`/frotas/veiculo/${veiculo.codveiculo}/view`}>
                                                                <VisibilityOutlinedIcon
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Excluir">
                                                            <DeleteForeverOutlinedIcon
                                                                onMouseEnter={this.handleDeleteIconMouseEnter}
                                                                onMouseLeave={this.handleIconMouseLeave}
                                                                onClick={() => this.handleOpen(
                                                                    veiculo.codveiculo,
                                                                    veiculo.nroveiculo
                                                                )}
                                                                style={actionIcon}
                                                            />
                                                        </Tooltip>
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>

                        <TablePagination
                            component="div"
                            count={totalItems}
                            page={page}
                            onPageChange={this.handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            rowsPerPageOptions={[10, 50, 100, 200]}
                            labelRowsPerPage="Registros por página"
                        />
                    </CardContent>
                </Card>

                <DeleteConfirmationModal
                    open={open}
                    itemId={selectedId}
                    message={`Confirma exclusão do veículo ${selectedDesc || ''} [${selectedId}]?`}
                    handleClose={this.handleClose}
                    handleDelete={this.handleConfirmDelete}
                />

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default VeiculoList;